import { Component, Input, HostBinding } from '@angular/core';
import { TabsComponent } from '../tabs.component';

@Component({
    selector: 'tab-item',
    templateUrl: './tab-item.component.html'
})
export class TabItemComponent {
    @Input('tabTitle') title: string;
    @Input('tabClick') click: string;
    @Input('tabLink') link: any;
    @Input() active = false;

    // New input property to control additional classes.
    @Input() extraClass: string = '';

    // Use HostBinding to bind the extraClass to the host element's class attribute.
    @HostBinding('class')
    get hostClasses(): string {
        // You can combine default classes with extraClass if needed.
        return this.extraClass;
    }

    constructor(tabs: TabsComponent) {
        tabs.addTab(this);
    }
}
